import apiService from "../../../Services/APIService";
import { checkAPIResponse } from "../../../Utils/APIResponseUtils";

export async function getIntgnConfig(getType) {
    try {
        const payload = { getType };
        const response = await apiService.getData(3, "getIntgn", payload);
        checkAPIResponse(response);
        const updatePackage = JSON.parse(response.updatePackage || "{}");
        const result = updatePackage?.Table1?.[0] || {};
        return result;
    } catch (error) {
        console.error("getIntgnConfig API error:", error);
        throw error;
    }
}

export async function setIntgnConfig(key = "", changeType, extraValues = []) {
    try {
        const payload = {
            changeType,
            key: key,
            value: "",
            extraValues: JSON.stringify(extraValues)
        };

		console.log(payload)
        const result = await apiService.sendChange(3, "setIntgn", payload);

        if (changeType.includes("WA")) {
            return result;
        }
		checkAPIResponse(result);
        return result;
    } catch (error) {
        console.error("setIntgnConfig API error:", error);
        throw error;
    }
}

export async function generateWDQR( changeType, key, values = [] ) {
	try{
		const payload = {
			changeType : "WD",
			key: key,
			value: "",
			values: JSON.stringify(values)
		};
		const result = await apiService.sendChange(14, "set", payload);
		checkAPIResponse(result);
		return result;
	}catch(error){
		console.error("generateWDQR API error:", error);
		throw error;
	}
}